namespace app.acessibilidade {

    import IDirective = angular.IDirective;
    import IDirectiveFactory = angular.IDirectiveFactory;
    import IScope = angular.IScope;
    import IAugmentedJQuery = angular.IAugmentedJQuery;
    import IAttributes = angular.IAttributes;

    class LibrasDirective implements IDirective {

        public restrict: string = 'AE';

        public scope: Object = {
        };

        public link(scope: IScope, el: IAugmentedJQuery, attrs: IAttributes) {
            jQuery("#vlibras-wrapper").show();
            scope.$on("$destroy", () => {
                jQuery("#vlibras-wrapper").hide();
            });
        }

        public static factory(): IDirectiveFactory {
            return () => {
                return new LibrasDirective();
            };
        }

    }

    angular.module('app.acessibilidade').directive('libras', LibrasDirective.factory());
}